import { temAcesso } from '@/shared/auth/temAcesso'

const Pagamentos = () => import('./Pagamentos.vue')
const Pagamento = () => import('./Pagamento.vue')

export default {
    path: 'pagamentos',
    name: 'Gescon_Gerentes_Pagamentos',
    component: Pagamentos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-GER-PAG-00')) {
            next()
        }
    },
    children: [
        {
            path: ':pagamentoId',
            name: 'Gescon_Gerentes_Pagamentos_Detalhar',
            component: Pagamento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-GER-PAG-00')) {
                    next()
                }
            }
        }
    ]
}
